import { createContext } from 'react'

export const DrawerContentContext = createContext(null)
